import CurvasCreditoWorkflowsPage from "src/v2/pages/TratamentoSpreads/tratamento-spreads"

export default CurvasCreditoWorkflowsPage
